import { PostActionTypeEnum } from "../../../../../../shared/modules/posting/types";
import { PostActionModel } from "../PostActionModel";

export default class DeletePostActionModel extends PostActionModel {
    type = PostActionTypeEnum.DeletePostAction;
}
